export default __webpack_public_path__ + "static/media/pic-1.fd47b9a5.jpg";